module.exports = __webpack_public_path__ + "img/fendt_small.a278331a.png";